module.exports = __webpack_public_path__ + "static/img/yiwu.0619e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/yiwu.png
// module id = Vscf
// module chunks = 1